export default "__VITE_ASSET__CJlnnYSo__"